<!--
 * @Author: your name
 * @Date: 2020-10-13 15:20:37
 * @LastEditTime: 2020-10-13 17:14:54
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \fp_h5\src\components\ShopAutoComplete.vue
-->

<template>
     <a-select show-search :value="value" placeholder="输入商户号" style="width: 200px"
         :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null"
         @search="handleSearch" @change="handleChange" allow-clear>
         <a-select-option v-for="d in data" :key="d.value">
            {{ d.value }}-{{ d.text }}
         </a-select-option>
     </a-select>
</template>
<script>
import { mapState } from "vuex";
export default {
    data() {
        return {
            data: [],
            value:undefined,
        }
    },

    props:{
        svalue:String
    },
    computed:{
        ...mapState('devicelog', {
            searchP: state => state.searchP,
        })
    },
    methods: {
        setInputVal(val){
            this.value = val
        },
        handleChange(value) {
            this.value = value;
            this.$emit('onShopCodeChange',value);
        },
        handleSearch(value) {
            let that = this;
            let c_params = {
                pageSize: 10,
                page: 1,
                urlparams: false,
                keyword: value,
                shoptype:'1'
            }

            that.$store.dispatch({
                type: this.searchP.version == 'V3.0' ? "devicelog/getShopListv3" : "devicelog/getShopList",
                params: c_params,
                showMsg: false
            }).then((res) => {
                if (res.data.success == 1) {
                    that.data = [];
                    let result = res.data.data.list;
                    if(!result){
                        return;
                    }
                    result.forEach(r => {
                        that.data.push({
                            value: r.shopcode,
                            text: r.shopname,
                        });
                    });
                }
            })
        },
    },
    watch:{
        
    },

};
</script>

<style scoped>

</style>
